import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import { frontPaths } from '@/config/frontPaths.ts'
import { LogoutGuard } from '@/core/guards/LogoutGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const UTILITIES_ROUTES: RouteObject[] = [
  {
    path: 'set-password',
    errorElement: <ErrorPage />,
    lazy: async () => {
      const SetPasswordPage = lazy(
        () => import('@/pages/setPassword/SetPasswordPage.tsx')
      )
      return {
        element: (
          <LogoutGuard ifLoggedTo={frontPaths.home}>
            <SetPasswordPage />
          </LogoutGuard>
        )
      }
    }
  }
]

export default UTILITIES_ROUTES
